import { render } from "./ReviewBox.vue?vue&type=template&id=4649a9bf"
import script from "./ReviewBox.vue?vue&type=script&lang=js"
export * from "./ReviewBox.vue?vue&type=script&lang=js"

import "./ReviewBox.vue?vue&type=style&index=0&id=4649a9bf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__